<template>
	<v-card class="mb-4 caption">
		<v-card-text class="py-2">
			<div class="d-flex align-center justify-space-between">
				<div class="d-flex align-center">
					<p class="font-weight-bold body-2 px-1 mb-0">Correos Enviados</p>
					<v-chip
						color="#524D4D"
						label
						outlined
						x-small
						class="ml-2"
					>
						<b>{{ emails.length }}</b>
					</v-chip>
				</div>
				<v-btn
					icon
					color="#524D4D"
					@click="showAll = !showAll"
				>
					<v-icon>{{showAll ? 'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
				</v-btn>
			</div>
			<div v-if="emails.length == 0" class="px-4 my-2">
				<p class="mb-0">Sin Emails Enviados</p>
			</div>
			<div v-for="(email, index) in final_emails" :key="'m-' + index">
				<div class="py-0 px-1 d-flex align-center justify-space-between">
					<div>
						<div class="d-flex align-center">
							<v-icon class="mr-2" small>mdi-email-outline</v-icon>
							<p class="mb-0 caption font-weight-bold">{{ email?.type }}</p>
						</div>
						<div class="d-flex align-center">
							<v-icon class="mr-2" small>mdi-calendar-blank-outline</v-icon>
							<p class="mb-0 caption">{{ email.created_at | toDateTime }}</p>
						</div>
					</div>
					<v-chip
						class="ma-2"
						color="#959595"
						x-small
						dark
					>
						{{email.reason}}
					</v-chip>
				</div>
				<v-divider class="my-1" v-show="index < (final_emails.length - 1)"></v-divider>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: 'Emails',
	props: {
		conversation: {
			type: Object,
			required: true
		}
	},
  data() {
    return {
			showAll: false,
    };
  },
  computed: {
		final_emails(){
			if(this.emails.length === 0) {
				return [];
			}
			if(this.showAll){
				return this.emails;
			}
			return [this.emails[0]];
		},
		emails(){
			const visitEmails = (this.conversation.schedule?.request_email || []).map(item => ({
				type: "Visita Técnica",
				reason: 'Solicitud de Pago/Confirmación',
				created_at: item.created_at
			}));
			const  visitAgendaEmails = (this.conversation.schedule?.user_schedule?.sent_reminders || []).map(item => ({
				type: "Visita Técnica",
				reason: 'Recordatorio Agenda',
				created_at: item.created_at
			}));
			const desarchiveEmails = (this.conversation.reports || []).flatMap(report =>
				(report.statuses || [])
					.filter(status => status.status === 2)
					.map(status => ({
						type: "Presupuesto Desarchivo",
						reason: 'Solicitud de Pago',
						created_at: status.created_at
					}))
			);
			const allEmails = [...visitEmails, ...desarchiveEmails, ...visitAgendaEmails].sort(
				(a, b) => new Date(a.created_at) - new Date(b.created_at)
			);
			return allEmails
		}
  },
	watch: {
	},
	mounted(){
	},
  methods: {
  },
};
</script>